import { isNullOrUndefined, isArray } from "util";

const loadFile = (name,directory) => {
    return () => import(`@/${directory}/${name}.vue`);
}

const load = (url) => {
    return () => import(`@/${url}.vue`);
}


/**
 * @description 判断一个对象是否存在key， 如果传入第二个参数key， 则是判断这个obj对象是否存在key这个属性
 * @param {待验证的对象} obj 
 * @param {待验证的键} key 
 */
 const hasKey = (obj, key) => {
    if (key)
        return key in obj;
    else
        return Object.keys(obj).length;
}

/**
 * @description 判断一个对象是否为空，如果对象是一个数组，同时判断是否长度为0.
 * @param {待验证的对象} obj 
 */
 const isNullOrEmpty = (obj) => {
    return isNullOrUndefined(obj) || (isArray(obj) ? obj.length == 0 : false);
}

export {
    loadFile,
    load,
    hasKey, 
    isNullOrEmpty
}